import React from 'react';
import { languageName } from '../utils/customReportUtils';

/** What was handed to dig.watch (page and newsletter drafts), so the link back is not lost. */
export default function PublishedLinks({ digwatchUrl, newsletters, missions }) {
  const drafts = Object.entries(newsletters || {});
  return (
    <>
      {missions?.sent_at && (
        <div className="custom-reports-newsletters">
          <span className="custom-reports-newsletters-label">Missions</span>
          <span className="custom-reports-newsletter">
            <strong>{[missions.country, missions.type, missions.day && `day ${missions.day}`, missions.session_number && `#${missions.session_number}`].filter(Boolean).join(' · ')}</strong>
            {missions.url
              ? <a href={missions.url} target="_blank" rel="noreferrer">{missions.url}</a>
              : <span>Sent</span>}
          </span>
        </div>
      )}
      {digwatchUrl && (
        <div className="custom-reports-newsletters">
          <span className="custom-reports-newsletters-label">DigWatch page</span>
          <span className="custom-reports-newsletter">
            <a href={digwatchUrl} target="_blank" rel="noreferrer">{digwatchUrl}</a>
          </span>
        </div>
      )}
      {drafts.length > 0 && (
        <div className="custom-reports-newsletters">
          <span className="custom-reports-newsletters-label">Newsletter drafts</span>
          {drafts.map(([code, entry]) => (
            <span key={code} className="custom-reports-newsletter">
              <strong>{languageName(code)}</strong>
              <a href={entry.edit_url || entry.url} target="_blank" rel="noreferrer">
                {entry.campaign_id ? `#${entry.campaign_id}` : 'open'}
              </a>
              {entry.preview_url && <a href={entry.preview_url} target="_blank" rel="noreferrer">preview</a>}
            </span>
          ))}
        </div>
      )}
    </>
  );
}
